import React from 'react'

export default function DelayedMountContainer(props: any) {
  const [isReady, setIsReady] = React.useState(false)

  React.useEffect(() => {
    setTimeout(() => {
      setIsReady(true)
    }, 0)
  }, [isReady])

  return isReady ? props.children : null
}
